function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
});

var SvgKeyboardShortcuts = function SvgKeyboardShortcuts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "6.75 109.8 204.7 103.27",
    id: "svg5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    label: "Layer 1",
    groupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "keyboard",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 3.1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43",
    width: 179.70035,
    height: 101.27324,
    x: 18.754305,
    y: 109.79794,
    ry: 7.8427091
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.310732,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43-7",
    width: 19.277452,
    height: 9.4850826,
    x: 34.519131,
    y: 125.38425,
    ry: 4.7425413
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.310732,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43-7-1",
    width: 19.277452,
    height: 9.4850826,
    x: 34.519138,
    y: 185.01692,
    ry: 4.7425413
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.58072,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43-7-1-0",
    width: 69.303101,
    height: 9.2150946,
    x: 64.831512,
    y: 185.15192,
    ry: 4.6075473
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.310732,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43-7-1-02",
    width: 19.277452,
    height: 9.4850826,
    x: 144.48756,
    y: 185.01692,
    ry: 4.7425413
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.310732,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43-7-1-2",
    width: 19.277452,
    height: 9.4850826,
    x: 164.60582,
    y: 125.38425,
    ry: 4.7425413
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3175",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.437636,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43-7-1-5",
    width: 38.75732,
    height: 9.3581781,
    x: 144.892,
    y: 165.4736,
    ry: 4.6790891
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.383651,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43-7-1-9",
    width: 29.58102,
    height: 9.4227037,
    x: 144.89757,
    y: -183.61813,
    ry: 4.7113519,
    transform: "rotate(90)"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.379946,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43-7-4",
    width: 29.033653,
    height: 9.4158688,
    x: 34.580112,
    y: 145.26527,
    ry: 4.7079344
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.440088,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect43-7-4-0",
    width: 39.203133,
    height: 9.3557262,
    x: 34.615429,
    y: 165.47484,
    ry: 4.6778631
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640",
    cx: 69.305679,
    cy: 130.12679,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-5",
    cx: 89.189507,
    cy: 130.12679,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-2",
    cx: 109.07333,
    cy: 130.12679,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-3",
    cx: 128.95717,
    cy: 130.12679,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-1",
    cx: 148.84099,
    cy: 130.12679,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-6",
    cx: 79.748421,
    cy: 149.97321,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-5-7",
    cx: 99.632248,
    cy: 149.97321,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-2-9",
    cx: 119.51608,
    cy: 149.97321,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-6-0",
    cx: 89.573112,
    cy: 170.15269,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-5-7-6",
    cx: 109.45695,
    cy: 170.15269,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-2-9-9",
    cx: 129.34079,
    cy: 170.15269,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-3-0",
    cx: 139.3999,
    cy: 149.97321,
    r: 3.8361077
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 3.09999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2640-1-7",
    cx: 159.28372,
    cy: 149.97321,
    r: 3.8361077
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKeyboardShortcuts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/keyboard-shortcuts.b3bcb60f.svg";
export { ForwardRef as ReactComponent };